import React from 'react';
import { Hero } from './components/Hero';
import { TopTestimonialsSection } from './components/TopTestimonialsSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { MastersSection } from './components/MastersSection';
import { OfferSection } from './components/OfferSection';
import { PricingSection } from './components/PricingSection';
import { CaseStudiesSection } from './components/CaseStudiesSection';
import { JourneyPath } from './components/JourneyPath';
export function App() {
  return <div className="w-full min-h-screen bg-gradient-to-br from-slate-950 via-purple-950 to-slate-950 relative overflow-hidden" data-id="element-0">
      {/* Film grain overlay */}
      <div className="fixed inset-0 opacity-[0.03] pointer-events-none z-50 film-grain" data-id="element-1" />
      {/* Vignette effect */}
      <div className="fixed inset-0 pointer-events-none z-40" style={{
      background: 'radial-gradient(circle at center, transparent 0%, rgba(0,0,0,0.4) 100%)'
    }} data-id="element-2" />
      {/* Journey path visualization */}
      <JourneyPath data-id="element-3" />
      <Hero data-id="element-4" />
      <TopTestimonialsSection data-id="element-5" />
      <ProblemSection data-id="element-6" />
      <SolutionSection data-id="element-7" />
      <MastersSection data-id="element-8" />
      <WhatYouGetSection data-id="element-9" />
      <OfferSection data-id="element-10" />
      <PricingSection data-id="element-11" />
      <CaseStudiesSection data-id="element-12" />
    </div>;
}